import React from 'react';
import PropTypes from 'prop-types';
import {
  VaDetails,
  VaLink,
} from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { formatDate } from '~/platform/shared/claims-appeals';
import { getEventContent } from '../../utils/appeals-v2-helpers';

const PastEventsSection = ({ events, missingEvents }) => {
  // va-details sets no :host display, unlike va-alert and va-summary-box, so
  // its host is inline and ignores vertical margin without a display utility.
  const missingEventsDetails = (
    <VaDetails
      class="vads-u-display--block vads-u-margin-bottom--4"
      label="Some events may not appear here"
    >
      <p>
        If you have questions about a past form or VA decision,{' '}
        <VaLink
          href="/get-help-from-accredited-representative/"
          text="contact your Veterans Service Organization (VSO) or representative"
        />
        , or call the VA benefits hotline at{' '}
        <va-telephone contact="8008271000" /> (
        <va-telephone contact="711" tty="true" />
        ).
      </p>
    </VaDetails>
  );
  let pastEventsList = [];
  if (events.length) {
    pastEventsList = events
      .sort((a, b) => new Date(b.date) - new Date(a.date))
      .map((event, index) => {
        const content = getEventContent(event);
        if (!content) {
          return null;
        }

        const { title, description } = content;
        const date = formatDate(event.date);
        return (
          <li
            key={`past-event-${index}`}
            className="vads-u-margin-bottom--2 vads-u-padding-bottom--1"
          >
            <h3 className="vads-u-margin-y--0">{date}</h3>
            <p className="vads-u-margin-y--0">{title}</p>
            <p
              className="item-description vads-u-margin-top--0p5 vads-u-margin-bottom--1"
              data-dd-privacy="mask"
              data-dd-action-name="item description"
            >
              {description}
            </p>
          </li>
        );
      })
      .filter(e => !!e); // Filter out the nulls
  }
  return (
    <div>
      <h2>Past events</h2>
      {missingEvents && missingEventsDetails}
      <ol className="va-list-horizontal appeal-past-events">
        {pastEventsList}
      </ol>
    </div>
  );
};

PastEventsSection.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      details: PropTypes.object,
    }),
  ).isRequired,
  missingEvents: PropTypes.bool.isRequired,
};

export default PastEventsSection;
